import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import "./index.scss";
import { CloseIcon } from "../../../images/icon";
import { parseJSON } from "../../MFEs/Monetization-Sdk/src/helper.js";
import { fetchUserObject } from "../../MFEs/Monetization-Sdk/src/fetchStore.js";
import pubsub from '@viewlift/pubsub';
import Spinner from "../../components/HomeLoadingScreen/Spinner";
import { ANALYTICS } from "../../helpers/analyticsMap.js";
const PersonalizationBanner = (prop) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    if (typeof window === "undefined")
        return;
    const isPersonlizationEnabled = (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.personalization) === null || _c === void 0 ? void 0 : _c.enablePersonalization) && ((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.personalization) === null || _f === void 0 ? void 0 : _f.enablePersonalizationBanner));
    if (!isPersonlizationEnabled)
        return;
    const isHomePage = (((_g = window === null || window === void 0 ? void 0 : window.location) === null || _g === void 0 ? void 0 : _g.pathname) === "/");
    if (!isHomePage)
        return;
    const location = useLocation();
    const [showPersonalizationBanner, setShowPersonalizationBanner] = useState(true);
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const genericMessage = (_j = (_h = window === null || window === void 0 ? void 0 : window.app_data) === null || _h === void 0 ? void 0 : _h.appcmsMain) === null || _j === void 0 ? void 0 : _j.genericMessages;
    const hasPersonalizationContent = (((_o = (_m = (_l = (_k = user === null || user === void 0 ? void 0 : user.profiles) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.contentPersonalization) === null || _m === void 0 ? void 0 : _m.teams) === null || _o === void 0 ? void 0 : _o.length) > 0) ||
        (((_s = (_r = (_q = (_p = user === null || user === void 0 ? void 0 : user.profiles) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.contentPersonalization) === null || _r === void 0 ? void 0 : _r.persons) === null || _s === void 0 ? void 0 : _s.length) > 0) ||
        (((_u = (_t = user === null || user === void 0 ? void 0 : user.contentPersonalization) === null || _t === void 0 ? void 0 : _t.teams) === null || _u === void 0 ? void 0 : _u.length) > 0) ||
        (((_w = (_v = user === null || user === void 0 ? void 0 : user.contentPersonalization) === null || _v === void 0 ? void 0 : _v.persons) === null || _w === void 0 ? void 0 : _w.length) > 0);
    const bannerText = hasPersonalizationContent ?
        ((genericMessage === null || genericMessage === void 0 ? void 0 : genericMessage.personalisationBannerText) || "This page is based on your interests. You can edit your personalization preferences at any time in your ") :
        ((genericMessage === null || genericMessage === void 0 ? void 0 : genericMessage.nonPersonalisationBannerText) || "You have not selected the favourite team yet, so to choose favourite visit ");
    const bannerHyperlink = hasPersonalizationContent ?
        ((genericMessage === null || genericMessage === void 0 ? void 0 : genericMessage.personalisationBannerHyperlink) || "Account Settings") :
        ((genericMessage === null || genericMessage === void 0 ? void 0 : genericMessage.nonPersonalisationBannerHyperlink) || "Personalization");
    const doesUserClosedPersonalizedBanner = parseJSON(localStorage.getItem("hidePersonalizationBanner"));
    useEffect(() => {
        pubsub.subscribe('isPersonalizationContentUpdated', displayPersonalizationBanner);
        getUser();
        return () => {
            pubsub.unsubscribe('isPersonalizationContentUpdated', displayPersonalizationBanner);
        };
    }, []);
    useEffect(() => {
        const pageRefreshStatus = parseJSON(localStorage.getItem("pageRefreshStatus"));
        if ((location === null || location === void 0 ? void 0 : location.pathname) === "/" && pageRefreshStatus) {
            localStorage.setItem("pageRefreshStatus", JSON.stringify(false));
            window.location.reload();
            setIsLoading(true);
        }
    }, []);
    useEffect(() => {
        if (!user)
            return;
        const eventData = { text: (hasPersonalizationContent ? 'personalized' : 'non personalized') };
        pubsub.publish('user-analytics', { ename: ANALYTICS.PERSONALIZATION_POP_UP, data: eventData });
    }, [user]);
    function displayPersonalizationBanner(bannerVisibilityState) {
        localStorage.setItem("hidePersonalizationBanner", JSON.stringify(!bannerVisibilityState));
        setShowPersonalizationBanner(bannerVisibilityState);
    }
    async function getUser() {
        const user = fetchUserObject();
        if (!user)
            return;
        setUser(user);
    }
    function handleLinkClick() {
        const eventData = hasPersonalizationContent ? { "edit": "personalized" } : { "edit": "non personalized" };
        pubsub.publish('user-analytics', { ename: ANALYTICS.PERSONALIZATION_EDIT_POP_UP, data: eventData });
    }
    if (isLoading)
        return React.createElement(Spinner, null);
    if (!user)
        return;
    if (!showPersonalizationBanner)
        return;
    if (doesUserClosedPersonalizedBanner)
        return;
    return (React.createElement("div", { className: 'personalization-banner-container' },
        React.createElement("div", { className: 'personalization-banner' },
            React.createElement("div", { className: 'banner-text' },
                React.createElement("div", null,
                    bannerText,
                    React.createElement(Link, { to: "/user-personalization", className: 'hyperlink', onClick: handleLinkClick }, bannerHyperlink))),
            React.createElement("div", { className: 'cancel-icon' },
                React.createElement(CloseIcon, { onClick: () => displayPersonalizationBanner(false) })))));
};
export default PersonalizationBanner;
